/* eslint-disable */
import { connect } from 'react-redux';
import {
	// useCallback,
	useEffect,
	useMemo,
	useState,
} from 'react';
import moment from 'moment';
import drawerActions from '../../../Actions/drawer.actions';
import BaseDrawer from '../BaseDrawer/BaseDrawer';
import { useAuth } from '@/Components/Auth/Login/auth';
import { Label } from '@/Components/ui/label';
import { UYDateRange } from '@/Components/Forms/Payment Settlements/Calender/UYDateRange';
import DatePickerCustom from '@/Components/DatePickerCustom/DatePickerCustom';
import {
	Tabs, TabsList, TabsTrigger
} from '@/Components/ui/tabs';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import { handleResponseStreamDownload } from '@/Helpers';
import { notificationServices } from '@/Services';
import ScanWiseTable from './ScanWiseTable';
import DayWiseTable from './DayWiseTable';
import { BackdropLoader } from '@/Components/Loaders';
import ProcessDayWiseTable from './ProcessDayWiseTable';
import ProcessScanWiseTable from './ProcessScanWiseTable';
import AssetScanWiseTable from './AssetScanWiseTable';
import { QrWiseTable } from './qrWiseTable';
import PackScanWiseTable from './PackScanWiseTable';
import PackDayWiseTable from './PackDayWiseTable';
import PackQrTable from './PackQrTable';
import { ChildQrActivitiesModal } from '@/Components/Modals/ChildQrActivitiesModal';
import BatchWiseTable from './BatchWiseTable';

// Lower bound for the "all available stock" batch view — effectively "no start
// date" so every batch (irrespective of created-at) is returned before we filter
// down to available > 0.
const ALL_AVAILABLE_FROM = '2000-01-01';

const StockHistoryDrawer = (props) => {
	// eslint-disable-next-line no-unused-vars
	const { show, data, toggleDrawer, stores } = props;
	const { selectedStore = null } = data;
	const { userConfig = {}, appConfig = {} } = useAuth();
	const { userRolesDict } = userConfig || {};
	const validRoles = Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') || Object?.values?.(userRolesDict ?? {}).includes('CXO Office') || Object?.values?.(userRolesDict ?? {}).includes('internal') || Object?.values?.(userRolesDict ?? {}).includes('Procurement');
	const { measurement } = appConfig?.configs ?? {};
	const [loading, setLoading] = useState(false);

	const [skuTrail, setSkuTrail] = useState([]);
	const [qrPage, setQrPage] = useState(1);
	const [qrTotal, setQrTotal] = useState(0);
	const QR_PAGE_SIZE = 20;
	// Child-QR search — only active for PACKS type. Sent to BE on Enter.
	const [childQrSearch, setChildQrSearch] = useState('');
	// eslint-disable-next-line no-unused-vars
	const [dataType, setDataType] = useState('scan_wise');
	const [dateRange, setDateRange] = useState({
		from: new Date(),
		to: new Date(),
		active: false,
	});
	// Batch-wise "all available stock" mode: show every batch with available > 0
	// irrespective of the created-at date filter. Toggled via the header buttons.
	const [showAllAvailableBatches, setShowAllAvailableBatches] = useState(false);

	const onClose = () => {
		toggleDrawer(false, {});
	};
	const fetchAssetTrail = async (filters) => {
		setLoading(true);
		try {
			const req = {
				data: {
					storeId: selectedStore?.id,
					assetTypeId: data?.itemDetails?.assetTypeId,
					dateRangeFilter: {
						from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
						to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
					},
				},
			};
			const assetResponse = await inventoryAnalyticsServices.fetchAssetTrail(req);
			if (assetResponse?.statusCode === 200) {
				setSkuTrail(assetResponse?.data);
			}
		} catch (error) {
			console.log('erorrr', error);
		} finally {
			setLoading(false);
		}
	};

	const fetchScanWiseTrail = async (filters) => {
		setLoading(true);
		try {
			const response = await inventoryAnalyticsServices.scanWiseSkuTrail({
				data: {
					variantId: data?.itemDetails?.variantId,
					productId: data?.itemDetails?.id,
					...(data?.type !== "PROCESS_REPORT" && data?.assetId && {
						assetId: data?.assetId,
					}),
					...(data?.type === 'PROCESS_REPORT' && {
						processId: data?.processId,
					}),
					...(data?.type !== 'PROCESS_REPORT' && {
						storeId: data?.itemDetails?.storeId,
					}),
					dateRangeFilter: {
						from: moment(filters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
					},
				},
			}, data?.type === 'PROCESS_REPORT' ? 'PROCESS_REPORT' : null);
			if (response?.responseCode === 'SS-001') {
				setSkuTrail(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('erorrr', error);
		} finally {
			setLoading(false);
		}
	};

	const handleProcessScanWiseExport = async () => {
		setLoading(true);
		try {
			const from = moment(dateRange?.from).format('YYYY-MM-DD');
			const to = moment(dateRange?.to).format('YYYY-MM-DD');
			const response = await inventoryAnalyticsServices.processScanWiseExport({
				data: {
					variantId: data?.itemDetails?.variantId,
					productId: data?.itemDetails?.id,
					processId: data?.processId,
					dateRangeFilter: { from, to },
				},
			});
			if (response?.ok) {
				await handleResponseStreamDownload(
					response,
					`ProcessStock_ScanWise_${data?.itemDetails?.variantId ?? ''}_${from}_${to}.csv`
				);
				notificationServices.generateNotification({
					type: 'success',
					message: 'Exported successfully',
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Some error occurred while exporting',
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('erorrr', error);
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error occurred while exporting',
			});
		} finally {
			setLoading(false);
		}
	};

	const fetchDayWiseTrail = async (filters) => {
		setLoading(true);
		try {
			const response = await inventoryAnalyticsServices.dayWiseSkuTrail({
				data: {
					...(!data?.allVariants && data?.itemDetails?.variantId && {
						variantId: data?.itemDetails?.variantId,
					}),
					...(data?.type !== "PROCESS_REPORT" && data?.assetId && {
						assetId: data?.assetId,
					}),
					productId: data?.itemDetails?.id,
					...(data?.type !== 'PROCESS_REPORT' && {
						storeId: data?.itemDetails?.storeId,
					}),
					dateRangeFilter: {
						from: moment(filters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
					},
				},
			});
			if (response?.responseCode === 'SS-001') {
				setSkuTrail(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('erorrr', error);
		} finally {
			setLoading(false);
		}
	};

	const fetchBatchWiseTrail = async (filters, allAvailable = false) => {
		setLoading(true);
		try {
			// In "all available" mode we ignore the created-at date filter and pull
			// every batch across a wide window, then keep only those with available
			// stock > 0. `allBatches` is sent for the BE to optimise if/when supported.
			const dateRangeFilter = allAvailable
				? { from: ALL_AVAILABLE_FROM, to: moment().format('YYYY-MM-DD') }
				: {
					from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
					to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
				};
			const response = await inventoryAnalyticsServices.batchWiseSkuTrail({
				data: {
					variantId: data?.itemDetails?.variantId,
					...(allAvailable && { allBatches: true }),
					dateRangeFilter,
				},
			});
			if (response?.responseCode === 'SS-001') {
				const rows = response?.data ?? [];
				setSkuTrail(
					allAvailable
						? rows.filter((row) => Number(row?.available) > 0)
						: rows
				);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('erorrr', error);
		} finally {
			setLoading(false);
		}
	};

	const handleShowAllAvailableStock = () => {
		setShowAllAvailableBatches(true);
		setSkuTrail([]);
		fetchBatchWiseTrail(null, true);
	};

	const handleShowDateWiseBatches = () => {
		setShowAllAvailableBatches(false);
		setSkuTrail([]);
		fetchBatchWiseTrail({
			dateRange: { from: dateRange?.from, to: dateRange?.to },
		});
	};

	const fetchQRTabData = async () => {
		setLoading(true);
		try {
			const response = await inventoryAnalyticsServices.qrTabData({
				data: {
					...(!data?.allVariants && data?.itemDetails?.variantId && {
						variantId: data?.itemDetails?.variantId,
					}),
					storeId: data?.itemDetails?.storeId,
					productId: data?.itemDetails?.id,
				},
			})
			if (response?.responseCode === 'SS-001') {
				setSkuTrail(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('erorrr', error);
		} finally {
			setLoading(false);
		}
	};

	const fetchProcessQRTabData = async (page = 1) => {
		setLoading(true);
		try {
			const response = await inventoryAnalyticsServices.processQrTabData({
				data: {
					...(!data?.allVariants && data?.itemDetails?.variantId && {
						variantId: data?.itemDetails?.variantId,
					}),
					productId: data?.itemDetails?.id,
					processId: data?.processId,
					page,
					pageSize: QR_PAGE_SIZE,
				},
			});
			if (response?.responseCode === 'SS-001') {
				setSkuTrail(response?.data);
				setQrTotal(response?.total ?? 0);
				setQrPage(page);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('erorrr', error);
		} finally {
			setLoading(false);
		}
	};

	// Pack Trail fetch functions
	const fetchPackScanWiseTrail = async (filters, childQr) => {
		setLoading(true);
		try {
			const response = await inventoryAnalyticsServices.packScanWiseTrail({
				data: {
					packId: data?.packDetails?.packId,
					packagingMappingId: data?.packDetails?.packagingMappingId,
					packSize: data?.packDetails?.packSize,
					productId: data?.itemDetails?.id,
					childVariantId: data?.itemDetails?.variantId,
					variantId: data?.itemDetails?.variantId,
					storeId: data?.selectedStore,
					dateRangeFilter: {
						from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
						to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
					},
					...(childQr ? { childQr } : {}),
				},
			});
			if (response?.responseCode === 'SS-001') {
				setSkuTrail(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('error', error);
		} finally {
			setLoading(false);
		}
	};

	// QR tab fetcher for PACKS — paginated. Receives all pack rows (active+inactive)
	// for the current (packagingMappingId, storeId). BE echoes page/total/pageSize
	// so we can wire pagination directly.
	const fetchPackQrList = async (page = 1, childQr) => {
		setLoading(true);
		try {
			const response = await inventoryAnalyticsServices.fmcgPackQrList({
				data: {
					packagingMappingId: data?.packDetails?.packagingMappingId,
					storeId: data?.selectedStore,
					childVariantId: data?.itemDetails?.variantId,
					page,
					pageSize: QR_PAGE_SIZE,
					...(childQr ? { childQr } : {}),
				},
			});
			if (response?.responseCode === 'SS-001') {
				setSkuTrail(response?.data || []);
				setQrPage(response?.page || page);
				setQrTotal(response?.total || 0);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('error', error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		setSkuTrail([]);
		setDataType('scan_wise');
		setChildQrSearch('');
	}, [show]);

	useEffect(() => {
		if (data?.type === 'ASSET_REPORT') {
			fetchAssetTrail({
				dateRange: {
					from: dateRange?.from,
					to: dateRange?.to,
				},
			});
			return;
		}
		// Handle PACKS type - fetch pack trail on mount.
		// Default range bumped to 30 days since FMCG packs typically live longer
		// in inventory than per-stock items.
		if (data?.type === 'PACKS' && show) {
			const defaultDateRange = {
				from: moment().startOf('day').subtract(30, 'days').toDate(),
				to: moment().startOf('day').toDate(),
			};
			setDateRange({
				...defaultDateRange,
				active: true,
			});
			if (dataType === 'scan_wise') {
				fetchPackScanWiseTrail({ dateRange: defaultDateRange }, childQrSearch || undefined);
			}
			if (dataType === 'qr_tab') {
				setQrPage(1);
				setQrTotal(0);
				fetchPackQrList(1, childQrSearch || undefined);
			}
			return;
		}
	}, [data?.type, show]);

	useEffect(() => {
		let updatedAt = new Date();
		if (data?.type == "PACKS") {
			return;
		}
		if (data?.itemDetails?.lastUpdatedAt) {
			updatedAt = new Date(data?.itemDetails?.lastUpdatedAt);
		}
		if (data?.type === 'PROCESS_REPORT' || data?.type === '') {
			// All-items (no single product selected) trail is heavy across many
			// SKUs, so it defaults to and only allows a single day, not a range.
			const dateRangeTemp = data?.allVariants
				? {
					from: moment(data?.lastUpdatedAt).startOf('day').toDate(),
					to: moment(data?.lastUpdatedAt).startOf('day').toDate(),
				}
				: {
					from: moment(data?.lastUpdatedAt).startOf('day').subtract(10, 'days').toDate(),
					to: moment(data?.lastUpdatedAt).startOf('day').toDate(),
				};
			setDateRange({
				...dateRangeTemp,
				active: true,
			});
			if (data?.type === 'PROCESS_REPORT' && show) {
				fetchScanWiseTrail({ dateRange: dateRangeTemp });
			}
			return;
		}
		if (show && data?.itemDetails?.skuType === 'PRODUCT') {
			setDateRange({
				from: moment(updatedAt).startOf('day').subtract(6, 'days').toDate(),
				to: moment(updatedAt).startOf('day').toDate(),
				active: true,
			});
			if (dataType === 'scan_wise') {
				fetchScanWiseTrail({
					dateRange: {
						from: moment(updatedAt)
							.startOf('day')
							.subtract(6, 'days')
							.toDate(),
						to: moment(updatedAt).startOf('day').toDate(),
					},
				});
			}
			if (dataType === 'day_wise') {
				fetchDayWiseTrail({
					dateRange: {
						from: moment(updatedAt)
							.startOf('day')
							.subtract(6, 'days')
							.toDate(),
						to: moment(updatedAt).startOf('day').toDate(),
					},
				});
			}
		} else if (show && ['INGREDIENT', 'PACKAGING', 'OTHER']?.includes(data?.itemDetails?.skuType)) {
			setDateRange({
				from: moment(updatedAt)
					.startOf('day')
					.subtract(1, 'month')
					.toDate(),
				to: moment(updatedAt).startOf('day').toDate(),
				active: true,
			});
			if (dataType === 'scan_wise') {
				fetchScanWiseTrail({
					dateRange: {
						from: moment(updatedAt)
							.startOf('day')
							.subtract(1, 'month')
							.toDate(),
						to: moment(updatedAt).startOf('day').toDate(),
					},
				});
			}
			if (dataType === 'day_wise') {
				fetchDayWiseTrail({
					dateRange: {
						from: moment(updatedAt)
							.startOf('day')
							.subtract(1, 'month')
							.toDate(),
						to: moment(updatedAt).startOf('day').toDate(),
					},
				});
			}
		}
	}, [show, data?.itemDetails?.skuType, data?.type]);

	const dateRangeFilterArray = useMemo(() => {
		return [
			{
				startDate: dateRange.from,
				endDate: dateRange.to,
				key: 'selection',
			},
		];
	}, [dateRange]);

	// Date range handed to the batch table (export + drill-down sub-rows). In
	// "all available" mode this widens to the full window so those stay in sync
	// with the on-screen, date-agnostic list.
	const effectiveBatchDateRange = useMemo(() => (
		showAllAvailableBatches
			? { from: moment(ALL_AVAILABLE_FROM).toDate(), to: new Date(), active: true }
			: dateRange
	), [showAllAvailableBatches, dateRange]);

	const setDate = (newDate) => {
		const { startDate: from, endDate: to } = newDate?.selection ?? {};

		setDateRange({
			active: true,
			from,
			to,
		});
		if (data?.type === 'ASSET_REPORT') {
			fetchAssetTrail({
				dateRange: {
					from,
					to,
				},
			});
		} else if (data?.type === 'PACKS') {
			// Handle PACKS type date range change
			if (dataType === 'scan_wise') {
				fetchPackScanWiseTrail({
					dateRange: { from, to },
				}, childQrSearch || undefined);
			}
		} else {
			if (dataType === 'scan_wise') {
				fetchScanWiseTrail({
					dateRange: {
						from,
						to,
					},
				});
			}
			if (dataType === 'day_wise') {
				fetchDayWiseTrail({
					dateRange: {
						from,
						to,
					},
				});
			}
			if (dataType === 'batch_wise') {
				fetchBatchWiseTrail({
					dateRange: {
						from,
						to,
					},
				});
			}
		}
	};
	const renderBtns = () => {
		return (
			<div className='flex justify-end gap-2 text-sm font-semibold'>
				Current Stock : {data?.currentStock}
			</div>
		);
	};

	return (
		<BaseDrawer
			style={{
				width: '80%',
			}}
			header={data?.headings?.[dataType] || data?.heading}
			open={show}
			onClose={onClose}
			renderBtns={renderBtns}
			size='full'
		>
			<BackdropLoader isLoading={loading} showProgress />
			<div className='w-full flex justify-between items-center px-2 py-4'>
				{data?.type !== 'ASSET_REPORT' && (
					<div className='flex flex-col gap-1'>
						<Tabs
							value={dataType}
							onValueChange={(value) => {
								setDataType(value);
								setSkuTrail([]);
								// Any tab switch resets batch view back to date-wise.
								setShowAllAvailableBatches(false);
								// Handle PACKS type
								if (data?.type === 'PACKS') {
									if (value === 'scan_wise') {
										fetchPackScanWiseTrail({
											dateRange: {
												from: dateRange?.from,
												to: dateRange?.to,
											},
										}, childQrSearch || undefined);
									}
									if (value === 'qr_tab') {
										setQrPage(1);
										setQrTotal(0);
										fetchPackQrList(1, childQrSearch || undefined);
									}
									return;
								}
								if (value === 'scan_wise') {
									fetchScanWiseTrail({
										dateRange: {
											from: dateRange?.from,
											to: dateRange?.to,
										},
									});
								}
								if (value === 'day_wise') {
									fetchDayWiseTrail({
										dateRange: {
											from: dateRange?.from,
											to: dateRange?.to,
										},
									});
								}
								if (value === 'batch_wise') {
									fetchBatchWiseTrail({
										dateRange: {
											from: dateRange?.from,
											to: dateRange?.to,
										},
									});
								}
								if (value === 'qr_tab') {
									setQrPage(1);
									setQrTotal(0);
									if (data?.type === 'PROCESS_REPORT') {
										fetchProcessQRTabData(1);
									} else {
										fetchQRTabData();
									}
								}
							}}
							defaultValue={dataType}
						>
							<TabsList className=''>
								<TabsTrigger
									className='data-[state=active]:bg-uy-color'
									value='scan_wise'
								>
									Scan-Wise
								</TabsTrigger>
								{data?.type !== 'PROCESS_REPORT' && data?.type !== 'PACKS' && (
									<TabsTrigger
										className='data-[state=active]:bg-uy-color'
										value='day_wise'
									>
										Day-Wise
									</TabsTrigger>
								)}
								{data?.type !== 'PROCESS_REPORT' && data?.type !== 'PACKS' && data?.itemDetails?.variantId && (
									<TabsTrigger
										className='data-[state=active]:bg-uy-color'
										value='batch_wise'
									>
										Batch Wise
									</TabsTrigger>
								)}
								{((data?.showQRTab && validRoles) || data?.type === 'PROCESS_REPORT' || data?.type === 'PACKS') && (
									<TabsTrigger
										className='data-[state=active]:bg-uy-color'
										value='qr_tab'
									>
										{data?.type === 'PACKS' ? 'Available Packs' : 'Available Stock'}
									</TabsTrigger>
								)}
							</TabsList>
						</Tabs>
					</div>
				)}
				{
					selectedStore?.title && (
						<div className='text-lg font-bold tracking-wide text-gray-800 bg-gray-100 px-4 py-2 rounded-lg shadow-sm'>
							{selectedStore?.title}
						</div>
					)
				}
				{data?.type === 'PACKS' && (
					<div className='flex flex-col gap-1'>
						<Label>Search by Child QR</Label>
						<input
							type='text'
							value={childQrSearch}
							onChange={(e) => setChildQrSearch(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									const q = childQrSearch.trim() || undefined;
									if (dataType === 'scan_wise') {
										fetchPackScanWiseTrail({ dateRange: { from: dateRange.from, to: dateRange.to } }, q);
									} else if (dataType === 'qr_tab') {
										setQrPage(1);
										setQrTotal(0);
										fetchPackQrList(1, q);
									}
								}
							}}
							placeholder='Enter child QR code...'
							className='h-8 px-2 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-400 w-52'
						/>
					</div>
				)}
				{dataType !== 'qr_tab' && (
					<div className='flex items-end gap-2'>
						{dataType === 'batch_wise' && (
							<button
								type='button'
								onClick={showAllAvailableBatches ? handleShowDateWiseBatches : handleShowAllAvailableStock}
								className='h-9 rounded-md border border-[#1d7044] px-4 py-2 text-sm font-semibold text-[#1d7044] transition-colors hover:bg-[#1d7044] hover:text-white'
							>
								{showAllAvailableBatches ? 'View Date Wise Batches' : 'Show All Available Stock'}
							</button>
						)}
						{!(dataType === 'batch_wise' && showAllAvailableBatches) && (
							<div className='flex flex-col gap-1'>
								<Label>{dataType === 'batch_wise' ? 'Select Created At Date' : 'Select Stock In Range'}</Label>
								{data?.allVariants ? (
									<DatePickerCustom
										selectedDate={dateRange?.from}
										selectDate={(date) => {
											if (!date) return;
											setDate({
												selection: {
													startDate: date,
													endDate: date,
												},
											});
										}}
										format='dd-MM-yyyy'
										oneTap
										cleanable={false}
										disableFutureDate
										placement='bottomEnd'
									/>
								) : (
									<UYDateRange
										disabled={false}
										dateRanges={dateRangeFilterArray}
										onDateRangeChange={setDate}
										enableOnlyBackwardSelection
										MAX={data?.type === 'PACKS' ? 180 : 32}
									/>
								)}
							</div>
						)}
					</div>
				)}
			</div>
			<div className='w-full overflow-auto !text-xs'>
				{
					data?.type === 'ASSET_REPORT' ? (
						<AssetScanWiseTable data={skuTrail} />
					) : (
						data?.type === 'PROCESS_REPORT' ? (
							<>
								{dataType === 'scan_wise' && (
									<ProcessScanWiseTable
										allVariants={data?.allVariants}
										itemDetails={data?.itemDetails}
										data={skuTrail}
										measurement={measurement}
										onExportClick={handleProcessScanWiseExport}
									/>
								)}
								{dataType === 'day_wise' && (
									<ProcessDayWiseTable
										allVariants={data?.allVariants}
										itemDetails={data?.itemDetails}
										data={skuTrail}
										measurement={measurement}
									/>
								)}
								{dataType === 'qr_tab' && (
									<QrWiseTable
										itemDetails={data?.itemDetails}
										data={skuTrail}
										measurement={measurement}
										page={qrPage}
										total={qrTotal}
										pageSize={QR_PAGE_SIZE}
										onPageChange={(p) => fetchProcessQRTabData(p)}
									/>
								)}
							</>
						) : data?.type === 'PACKS' ? (
							<>
								{dataType === 'scan_wise' && (
									<PackScanWiseTable
										itemDetails={data?.itemDetails}
										packDetails={data?.packDetails}
										data={skuTrail}
									/>
								)}
								{dataType === 'qr_tab' && (
									<PackQrTable
										itemDetails={data?.itemDetails}
										packDetails={data?.packDetails}
										data={skuTrail}
										page={qrPage}
										total={qrTotal}
										pageSize={QR_PAGE_SIZE}
										onPageChange={(p) => fetchPackQrList(p, childQrSearch || undefined)}
									/>
								)}
							</>
						) : (
							<>
								{dataType === 'scan_wise' && (
									<ScanWiseTable
										itemDetails={data?.itemDetails}
										data={skuTrail}
										measurement={measurement}
									/>
								)}
								{dataType === 'day_wise' && (
									<DayWiseTable
										itemDetails={data?.itemDetails}
										data={skuTrail}
										measurement={measurement}
									/>
								)}
								{dataType === 'batch_wise' && (
									<BatchWiseTable
										itemDetails={data?.itemDetails}
										data={skuTrail}
										dateRange={effectiveBatchDateRange}
										allAvailable={showAllAvailableBatches}
									/>
								)}
								{dataType === 'qr_tab' && (
									<QrWiseTable
										itemDetails={data?.itemDetails}
										data={skuTrail}
										measurement={measurement}
									/>
								)}
							</>
						)
					)
				}
			</div>
			{/* Mounted alongside the drawer so clicking a Pack QR in
			    PackScanWiseTable opens the child-activity modal in the
			    same DOM subtree. State held in Redux
			    (state.modal.childQrActivitiesModal). */}
			<ChildQrActivitiesModal />
		</BaseDrawer>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state?.drawer?.stockHistoryDrawer;
	const stores = state?.form?.STORES?.data?.LIST;
	return {
		show,
		data,
		stores,
	};
};

const mapDispatchToProps = {
	toggleDrawer: drawerActions.toggleStockHistoryDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(StockHistoryDrawer);
